import { TextInput } from "components/core";
import { DistrictPicker } from "containers";
import { FormikProps } from "formik";
import { FC } from "react";
import { ICreatePremiumServiceInterestFormSchema } from "./schema";

export interface CreatePremiumServiceInterestFormProps {
  form: FormikProps<ICreatePremiumServiceInterestFormSchema>;
}

export const CreatePremiumServiceInterestForm: FC<
  CreatePremiumServiceInterestFormProps
> = ({ form }) => {
  return (
    <div className="space-y-6 divide-y divide-gray-200">
      <div>
        <span className="text-xs font-light">Location</span>
        <div className="grid grid-cols-1 gap-6 mt-2">
          <DistrictPicker
            id="district"
            rawId={true}
            {...form}
            label="District (if available)"
          />
        </div>
      </div>
      <div className="pt-2">
        <span className="text-xs font-light">Customer Details</span>
        <div className="grid grid-cols-2 gap-6 mt-2">
          <div>
            <TextInput
              id="customer.fullName"
              label="Full Name"
              type="text"
              placeholder="e.g. Solomon Nana Kweku Bekoe"
              required
              {...form}
            />
          </div>
          <div>
            <TextInput
              id="customer.phoneNumber"
              label="Phone Number"
              type="text"
              placeholder="e.g. 0244123456"
              required
              {...form}
            />
          </div>
          <div className="col-span-2">
            <TextInput
              id="customer.digitalAddress"
              label="Digital Address"
              type="text"
              placeholder="e.g. AE-0223-1090"
              required
              {...form}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreatePremiumServiceInterestForm;
